import * as React from "react";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useContext } from "react";
import { AuthContext } from "../context/AuthContext";
import { themeMxm } from "../Config/theme";
import Box from "@mui/material/Box";
import Stepper from "@mui/material/Stepper";
import Step from "@mui/material/Step";
import StepLabel from "@mui/material/StepLabel";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import JobsForm from "./JobsForm";
import JobParts from "./JobsParts";
import Card from "@mui/material/Card";
import CardHeader from "@mui/material/CardHeader";
import CardActions from "@mui/material/CardActions";
import CardContent from "@mui/material/CardContent";
import {
  Divider,
  Chip,
  Stack,
  List,
  ListItem,
  ListItemText,
  ListSubheader,
  Modal,
  Container,
  ButtonGroup,
  Grid,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
} from "@mui/material";
//import { parts } from "./JobsParts";
import { serverURL, HAMLET_API } from "../Config/config";
import {
  getPrivateElementByID,
  addPrivateElement,
  putPrivateElement,
  fechtData,
} from "../customHooks/FetchDataHook";
import { calcularLomo } from "../jobViewer/JobDetail";
import ErrorMessage from "../ErrorMessage/ErrorMessage";
import PartCard from "./PartCard";
import paperTexture from "../../img/Texturas/craft-texture-brown-journal-note.jpg";
import darkWoodBackground from "../../img/Dark_Wood_Background.jpg";

import {
  addElementToArray,
  removeElementFromArray,
  replaceElementInArray,
} from "../utils/generalData/arrayNormalizer";
import { use } from "react";

const encodePathSegment = (value) =>
  encodeURIComponent(value === null || value === undefined ? "" : value.toString());

export const buildPdfUploadUrl = (baseUrl, cliente, trabajo, parte) => {
  const safeBase = (baseUrl || "").replace(/\/+$/, "");
  return `${safeBase}/${encodePathSegment(cliente)}/${encodePathSegment(trabajo)}/${encodePathSegment(parte)}`;
};

export default function MyStepper(props) {
  const [activeStep, setActiveStep] = React.useState(0);
  const [skipped, setSkipped] = React.useState(new Set());
  const [allParts, setAllParts] = React.useState([]);
  const [useParts, setParts] = React.useState(props.job?.Partes || []);
  const [usePartToEdit, setPartToEdit] = React.useState(null);
  const [useJobType, setJobType] = React.useState(props.job?.Tipo[0] || {});
  const [useJob, setJob] = React.useState(props.job || null);
  const [useError, setError] = React.useState(null);
  const [stocks, setStocks] = React.useState([]);
  const [newJobId, setNewJobId] = React.useState(null);
  const [useModal, setModal] = React.useState(false);
  const [copyDialogOpen, setCopyDialogOpen] = React.useState(false);
  const [copyDraftName, setCopyDraftName] = React.useState("");
  const [copySourcePart, setCopySourcePart] = React.useState(null);
  const context = useContext(AuthContext);
  const navigate = useNavigate();

  const handleJobTypeChange = (e) => {
    setJobType(e.target.value);
  };

  const getMode = (job) => {
    if (!job) return "new";

    if (job.Description && !job._id) return "import";

    if (job._id) return "edit";

    return "new"; // fallback seguro
  };

  const [useMode, setMode] = React.useState(getMode(props.job));

  const parts = allParts;

  const addParts = (newPart) => {
    console.log("add");
    console.log(newPart);
    try {
      const getStock = async (id) => {
        const stock = await getPrivateElementByID("materiales", id);
        newPart.partStock = stock;
      };
      getStock(newPart.partStock);
    } catch (e) {
      setError(e);
    }
    const part = parts.filter((part) => part._id === newPart.jobParts);
    newPart.jobParts = part;

    let partes = addElementToArray(newPart, useParts);

    try {
      setParts(partes);
      handleNext();
    } catch (e) {
      setError(e);
    }
  };

  const removePart = (n) => {
    const partsOk = removeElementFromArray(n, useParts);
    setParts(partsOk);
  };

  const replacePart = (newPart) => {
    console.log("Replace");
    console.log(newPart);
    try {
      const getStock = async (id) => {
        const stock = await getPrivateElementByID("materiales", id);
        newPart.partStock = stock;
      };
      getStock(newPart.partStock);
    } catch (e) {
      setError(e);
    }
    const part = parts.filter((part) => part._id === newPart.jobParts);
    newPart.jobParts = part;

    const partsOk = replaceElementInArray(
      newPart,
      useParts[usePartToEdit.index],
      useParts,
    );
    setParts(partsOk);
    setPartToEdit(null);
    handleNext();
  };

  const editPart = (n) => {
    const res = setPartToEdit({ part: useParts[n], index: n });
    return res;
  };

  // Abre el diálogo con los datos de la parte a copiar
  const openCopyDialog = (part) => {
    setCopySourcePart(part);
    setCopyDraftName(
      part && part.Name ? `${part.Name} - copia` : "Nueva parte - copia",
    );
    setCopyDialogOpen(true);
  };

  const handleConfirmCopy = () => {
    if (!copySourcePart) {
      setCopyDialogOpen(false);
      return;
    }
    // Crear una copia shallow para evitar mutar el original
    const newPart = { ...copySourcePart, Name: copyDraftName };
    const partes = addElementToArray(newPart, useParts);
    setParts(partes);

    // Reset dialog state
    setCopyDialogOpen(false);
    setCopySourcePart(null);
    setCopyDraftName("");
  };

  const handleCancelCopy = () => {
    setCopyDialogOpen(false);
    setCopySourcePart(null);
    setCopyDraftName("");
  };

  // El siguiente array contiene los componentes
  // que se rendarizan en cada paso del stepper:

  const isStepOptional = (step) => {
    return step === 1;
  };

  const isStepSkipped = (step) => {
    return skipped.has(step);
  };

  const handleNext = () => {
    let newSkipped = skipped;
    let stepForward = useMode !== "new" && activeStep === 0 ? 2 : 1;

    if (isStepSkipped(activeStep)) {
      newSkipped = new Set(newSkipped.values());
      newSkipped.delete(activeStep);
    }
    setActiveStep((prevActiveStep) => prevActiveStep + stepForward);
    setSkipped(newSkipped);
  };

  const handleBack = () => {
    setActiveStep((prevActiveStep) => prevActiveStep - 1);
  };

  const resetError = () => {
    setError(null);
    setJob(props.job);
  };

  const handleSkip = () => {
    if (!isStepOptional(activeStep)) {
      // You probably want to guard against something like this,
      // it should never occur unless someone's actively trying to break something.
      throw new Error("You can't skip a step that isn't optional.");
    }

    setActiveStep((prevActiveStep) => prevActiveStep + 1);
    setSkipped((prevSkipped) => {
      const newSkipped = new Set(prevSkipped.values());
      newSkipped.add(activeStep);
      return newSkipped;
    });
  };

  const handlePost = async () => {
    const Job = useJob;
    Job.Partes = useParts;
    // Este forEach me parece que no hace falta...
    /* Job.Partes.forEach((part) => {
      part.Finishing = part.Finishing.map((f) => f._id);
    }); */
    if (useMode === "new" || useMode === "import") {
      Job.JobType = useJobType;
    } else if (useMode === "edit") {
      Job.JobType = props.job.Tipo[0];
    }

    try {
      const res = await addPrivateElement("Jobs", Job);
      setNewJobId(res.data);
      handleNext();
    } catch (e) {
      setError(e);
    }
  };

  const handleUpdate = async () => {
    const Job = useJob;
    Job.Partes = useParts;
    try {
      const res = await putPrivateElement(
        `${HAMLET_API}jobs/${props.job._id}`,
        Job,
      );
      handleNext();
    } catch (e) {
      setError(e);
    }
  };

  const handleReset = () => {
    setActiveStep(0);
    setParts(props.job?.Partes || []);
    setJobType(props.job?.Tipo[0] || {});
    setJob(props.job || null);
  };

  const steps = [
    [
      "Defina el tipo de producto",
      <JobsForm
        jobType={useJobType}
        setJobType={setJobType}
        data={useJob}
        setJob={setJob}
        continue={handleNext}
      />,
    ],
    [
      "Agregue las partes",
      <JobParts
        jobType={useJobType}
        job={useJob}
        addParts={addParts}
        replacePart={replacePart}
        editPart={usePartToEdit}
        setEditPart={setPartToEdit}
        useParts={useParts}
        parts={allParts}
        stocks={stocks}
      />,
    ],
    [
      "Confirme el pedido",
      <Box>
        <Typography variant="subtitle1">Partes del trabajo</Typography>
        <List sx={{ listStyleType: "bullet" }}>
          {useParts.map((part, index) => {
            return (
              <ListItem divider key={`${index}-Parte`}>
                <ListItemText
                  sx={{ display: "list-item" }}
                  primary={part.Name}
                  secondary={`${part?.partStock?.Tipo} ${part?.partStock?.Gramaje} ${part?.partStock?.Marca}`}
                />
              </ListItem>
            );
          })}
        </List>
      </Box>,
    ],
  ];

  // Nueva linea

  useEffect(() => {
    try {
      fechtData("jobParts", setAllParts);
      fechtData("materiales", setStocks);
    } catch (error) {
      setError(error);
    }
  }, [useJob, useParts]);

  const statusError = (
    <>
      {useError !== null && (
        <ErrorMessage
          title="Error al cargar datos"
          message={useError.response.data.message || useError.message}
          //color="success"
          action={resetError}
          buttonTxt="Reintentar"
        />
      )}
    </>
  );

  const success = (
    <Container disableGutters maxWidth={false} sx={{ margin: 0, padding: 0 }}>
      <Card raised sx={{ height: "100%" }}>
        <CardHeader
          title={useJob?.Nombre || "Nuevo Pedido"}
          subheader={useJob?.Cantidad || "Solicita tu presupuesto!"}
          action={
            <Button
              onClick={() => {
                navigate(-1);
              }}
            >
              Volver
            </Button>
          }
        />
        <Divider />
        <CardContent>
          <Grid
            container
            columns={12}
            sx={{ width: "100%", display: "flex", flexDirection: "row" }}
          >
            <Grid>
              <Stepper activeStep={activeStep}>
                {steps.map((label, index) => {
                  const stepProps = {};
                  const labelProps = {};
                  if (isStepOptional(index)) {
                    labelProps.optional = (
                      <Typography variant="caption" key={index}>
                        Opcional
                      </Typography>
                    );
                  }
                  if (isStepSkipped(index)) {
                    stepProps.completed = false;
                  }
                  return (
                    <Step key={index + "_label"} {...stepProps}>
                      <StepLabel {...labelProps}>{label[0]}</StepLabel>
                    </Step>
                  );
                })}
              </Stepper>
              {activeStep === steps.length ? (
                <React.Fragment>
                  <Typography sx={{ mt: 2, mb: 1 }}>
                    Todos los pasos completados,
                  </Typography>
                  <Box sx={{ display: "flex", flexDirection: "row", pt: 2 }}>
                    <Box sx={{ flex: "1 1 auto" }} />
                    <Button onClick={handleReset} variant="filled">
                      Reset
                    </Button>
                    <Button
                      onClick={() => navigate(`/jobs/edit/${newJobId}`)}
                      disabled={newJobId === null}
                      color="success"
                    >
                      Continuar...
                    </Button>
                  </Box>
                </React.Fragment>
              ) : (
                <React.Fragment>
                  <Typography sx={{ mt: 2, mb: 1 }}>
                    Step {activeStep + 1}
                  </Typography>
                  {steps[activeStep][1]}
                  <Box
                    sx={{
                      display: "flex",
                      flexDirection: "row",
                      p: 2,
                      mt: 1,
                      mb: 1,
                    }}
                  >
                    <ButtonGroup variant="contained">
                      <Button
                        color="info"
                        disabled={activeStep === 0}
                        onClick={handleBack}
                      >
                        {activeStep < steps.length - 1
                          ? "Modificar Datos del Trabajo"
                          : "Agregar más partes"}
                      </Button>
                      {isStepOptional(activeStep) && (
                        <Button color="info" onClick={handleSkip}>
                          Saltar
                        </Button>
                      )}
                      <Button
                        onClick={
                          activeStep === steps.length - 1
                            ? handlePost
                            : handleNext
                        }
                        color="success"
                        disabled={useJob === null}
                      >
                        {activeStep === steps.length - 1
                          ? "Enviar Nuevo Pedido"
                          : "Siguiente"}
                      </Button>
                      {useMode === "edit" &&
                        activeStep === steps.length - 1 && (
                          <Button onClick={handleUpdate} color="warning">
                            Guardar
                          </Button>
                        )}
                    </ButtonGroup>
                  </Box>

                  <Divider></Divider>
                </React.Fragment>
              )}
            </Grid>
            <Grid size={{ xs: 12, lg: 8 }}>
              <Container>
                <Grid
                  container
                  columns={12}
                  spacing={2}
                  overflow={"false"}
                  sx={{ height: "98%" }}
                >
                  {useParts?.map((part, index) => {
                    return (
                      <Grid
                        key={"Parte-" + index}
                        size={{
                          xs: 12,
                          sm: useParts.length < 3 ? 12 / useParts.length : 6,
                          md: useParts.length < 3 ? 12 / useParts.length : 6,
                          lg: useParts.length < 3 ? 12 / useParts.length : 4,
                        }}
                      >
                        <PartCard
                          part={part}
                          index={index}
                          editPart={editPart}
                          addPart={addParts}
                          copyPart={openCopyDialog} // <- USAR openCopyDialog
                          setActiveStep={setActiveStep}
                          removePart={removePart}
                          step={activeStep}
                          uploadSubDir={buildPdfUploadUrl(
                            context?.useSettings?.extensions?.pdfValidatorUrl,
                            useJob?.Company?.Nombre,
                            useJob?.Nombre,
                            `${index + 1}-${part.Name}`,
                          )} // Subdirectorio específico para esta parte
                        />
                      </Grid>
                    );
                  })}
                </Grid>
              </Container>
            </Grid>
          </Grid>
        </CardContent>
      </Card>
    </Container>
  );

  return useError !== null ? (
    statusError
  ) : (
    <>
      {success}
      <Dialog
        open={copyDialogOpen}
        onClose={handleCancelCopy}
        fullWidth
        maxWidth="sm"
      >
        <DialogTitle>Copiar parte</DialogTitle>
        <DialogContent>
          <TextField
            autoFocus
            margin="dense"
            label="Nombre de la nueva parte"
            type="text"
            fullWidth
            value={copyDraftName}
            onChange={(e) => setCopyDraftName(e.target.value)}
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCancelCopy}>Cancelar</Button>
          <Button
            onClick={handleConfirmCopy}
            variant="contained"
            color="primary"
          >
            Confirmar copia
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
}
